﻿(function () {
    "use strict";

    angular.module("app").controller("MyCompanyController", MyCompanyController);

    MyCompanyController.$inject = ["userApi"];

    function MyCompanyController(userApi) {
        var vm = this
        vm.$onInit = onInit;
        
        function checkAuthorization() {
            userApi.getCurrentUser().then((data) => {
                if (!data.roles || !data.roles.includes("Administrator")) {
                    window.location.href = "/"
                }
            })
        }

        function onInit() {
            checkAuthorization()
        }
    }
})();